// Client-side text validation aligned with backend limits
import i18n from '../i18n';

export const TEXT_LIMITS = {
  MIN_TEXT: 20,
  MAX_TEXT: 50000,
} as const;

export interface TextValidation {
  valid: boolean;
  error: string | null;
  warning: string | null;
  charCount: number;
  /** 'error' = red (<20), 'ok' = green (≥20) */
  level: 'error' | 'warning' | 'ok';
}

export function validateText(text: string): TextValidation {
  const trimmed = text.trim();
  const len = trimmed.length;

  if (len === 0) {
    return { valid: false, error: null, warning: null, charCount: len, level: 'error' };
  }

  if (len < TEXT_LIMITS.MIN_TEXT) {
    return {
      valid: false,
      error: i18n.t('validation.textMinLength', { min: TEXT_LIMITS.MIN_TEXT, current: len }),
      warning: null,
      charCount: len,
      level: 'error',
    };
  }

  if (len > TEXT_LIMITS.MAX_TEXT) {
    return {
      valid: false,
      error: i18n.t('validation.textMaxLength', { max: TEXT_LIMITS.MAX_TEXT.toLocaleString(), current: len.toLocaleString() }),
      warning: null,
      charCount: len,
      level: 'error',
    };
  }

  return { valid: true, error: null, warning: null, charCount: len, level: 'ok' };
}
